import { modalController } from '@ionic/core';
import { Component, Event, EventEmitter, h, Host, State } from '@stencil/core';

@Component({
  tag: 'revision-confirmation-modal',
  styleUrl: 'revision-confirmation-modal.css',
})
export class RevisionConfirmationModal {
  static async present(): Promise<boolean> {
    const modal = await modalController.create({
      component: 'revision-confirmation-modal',
      backdropDismiss: false,
      cssClass: 'modal-height-auto',
    });

    return new Promise(async resolve => {
      modal.addEventListener('confirm', () => {
        modal.dismiss();
        resolve(true);
      });
      modal.addEventListener('dismiss', () => {
        modal.dismiss();
        resolve(false);
      });
      await modal.present();
    });
  }

  @Event() confirm: EventEmitter<void>;
  @Event() dismiss: EventEmitter<void>;
  @State() isConfirming: boolean = false;

  get isMobile(): boolean {
    return globalThis.isMobile;
  }

  handleConfirm() {
    this.isConfirming = true;
    this.confirm.emit();
  }

  render() {
    return (
      <Host class="concourse-modal">
        <modal-header modalTitle="Create New Revision" onDismiss={() => this.dismiss.emit()}></modal-header>
        <div class="modal-content">
          <ion-list lines="none" class="ion-padding">
            <ion-item>
              <ion-label class="ion-text-wrap">
                <h2 class="typography-h6">You are about to create a new revision of this submittal.</h2>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label class="ion-text-wrap typography-body1">
                <p class="ion-margin-top">Creating a new revision will:</p>
                <ul class="revision-confirmation-modal__list">
                  <li>Start a new version of this submittal</li>
                  <li>Reset the workflow to the first step</li>
                  <li>Create a separate revision history</li>
                  <li>Require new files to be uploaded for the revised submittal</li>
                </ul>
                <p class="ion-margin-top">The previous revision and its history will remain accessible for reference.</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
        <ion-footer>
          <ion-toolbar>
            <ion-button
              slot="start"
              data-testid="revision-cancel-button"
              color="light"
              fill="outline"
              shape="round"
              onClick={() => this.dismiss.emit()}
              disabled={this.isConfirming}
            >
              Cancel
            </ion-button>
            <ion-button
              data-testid="revision-confirm-button"
              slot="end"
              color="primary"
              fill="solid"
              shape="round"
              disabled={this.isConfirming}
              onClick={() => this.handleConfirm()}
            >
              {this.isConfirming ? <ion-spinner name="crescent" size="small" slot="start"></ion-spinner> : null}
              {this.isConfirming ? 'Creating...' : 'Create Revision'}
            </ion-button>
          </ion-toolbar>
        </ion-footer>
      </Host>
    );
  }
}
